/**
 * @generated SignedSource<<f725fd96c7a7e106c21843ce289a0e68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SetAsDefaultItem_tab$data = {
  readonly __id: string;
  readonly id: string;
  readonly isDefault: boolean;
  readonly " $fragmentType": "SetAsDefaultItem_tab";
};
export type SetAsDefaultItem_tab$key = {
  readonly " $data"?: SetAsDefaultItem_tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"SetAsDefaultItem_tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SetAsDefaultItem_tab",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isDefault"
      },
      "action": "THROW",
      "path": "isDefault"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "__id"
          },
          "action": "THROW",
          "path": "__id"
        }
      ]
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "88982584cb03f7a8362df915df0c2838";

export default node;
